"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _cssUnitLessNumber = require("./cssUnitLessNumber.js");
var _reshowConstant = require("reshow-constant");
//@ts-check

/**
 * @param {string} v
 * @returns {string}
 */
var appendPx = function appendPx(v) {
  return v && _reshowConstant.NUMBER === typeof v ? v + "px" : v;
};

/**
 * @param {string} key
 * @param {any} value
 * @returns {string|string[]}
 */
var cssNumberToUnit = function cssNumberToUnit(key, value) {
  if (_cssUnitLessNumber.isUnitlessNumber[key]) {
    return value;
  }
  return (0, _reshowConstant.IS_ARRAY)(value) ? value.map(function (v) {
    return appendPx(v);
  }) : appendPx(value);
};
var _default = exports["default"] = cssNumberToUnit;
module.exports = exports.default;